






























































import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { RegularReport } from "@/typescript/models/reports/types";
import { Moment } from "@/typescript/lib/common/moment";
import TItemComponent from "@/components/common/table/TItemComponent.vue";
import TableComponent from "@/components/common/table/TableComponent.vue";
import TbodyComponent from "@/components/common/table/TbodyComponent.vue";
import TheadComponent from "@/components/common/table/TheadComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import { getRoutePath } from "@/router/routes";
import { getStoreReportApi } from "@/typescript/api_client/emesh_api/reports/store_report_api";
import { GetStoreReportResponse } from "../../../typescript/api_client/emesh_api/reports/types";
export { RegularReport, GetStoreReportResponse };

@Component({
  components: {
    TItemComponent,
    TableComponent,
    TbodyComponent,
    TheadComponent,
    EllipsisComponent
  }
})
export default class RegularReportComponent extends Vue {
  @Prop({
    default: false
  })
  disabled!: boolean;

  @Prop()
  isSensorDelete!: boolean;

  @Watch("disabled")
  changeDisabled(value: boolean) {
    this.internalDisabled = value;
  }

  reports: GetStoreReportResponse = [];
  internalDisabled: boolean = this.disabled;

  created() {
    this.setReports();
  }

  moveEditPage(report: RegularReport) {
    if (this.$store.state.storeIsRemoval) return;
    if (this.isSensorDelete) return;
    this.$router.push(
      getRoutePath("RegularReportsEditPage", {
        store_id: this.$route.params.store_id,
        report_id: report.setting_no
      })
    );
  }

  @Emit()
  deleteReport(no: number) {
    return no;
  }

  async setReports() {
    getStoreReportApi(this.$route.params.store_id).then(resp => {
      this.reports = resp;
    });
  }

  get deleteImageSrc(): string {
    return this.internalDisabled
      ? "/images/icons/btn_common_trash_disable.png"
      : "/images/icons/btn_common_trash.png";
  }

  get deleteImageStyle(): object {
    return this.internalDisabled ? { cursor: "default" } : {};
  }

  get listStyle(): object {
    return this.internalDisabled
      ? { backgroundColor: "#F4F5F7", cursor: "default" }
      : {};
  }

  convertDate(date: string): string {
    const moment = new Moment("YYYY/MM/DD HH:mm", date, "YYYY/MM/DD HH:mm:ss");
    return moment.getFormatDate();
  }

  makelink(reportId: number): string {
    return this.getRoutePath("RegularReportsEditPage", {
      store_id: this.$route.params.store_id,
      report_id: reportId
    });
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  convertReportType(type: number): string {
    switch (type) {
      case 1:
        return "月次";
      case 2:
        return "週次";
      case 3:
        return "日次";
    }

    return "期間選択";
  }
}
